import { NavParams } from 'ionic-angular';
import './email-popover.scss';
var EmailPopover = /** @class */ /*@__PURE__*/ (function () {
    function EmailPopover(navParams) {
        this.emails = navParams.get('emails');
    }
    return EmailPopover;
}());
export { EmailPopover };
